import request from "@utils/request";

export function fetchChangeSummaryData(query) {
    return request({
        url: "change-summary",
        method: "post",
        data: query
    });
}

export function getNetPositionDetail(query) {
    return request({
        url: "change-summary/detail",
        method: "post",
        data: query
    });
}